import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { motion, AnimatePresence } from 'framer-motion'
import { SnackbarWrapper, Message, CloseBtn } from './styles'
import { CloseIcon } from '../Icons'

export const SnackbarAlert = ({
  open,
  severity = 'info',
  message,
  onClose,
  autoHideDuration = 3000,
}) => {
  useEffect(() => {
    if (!open || !autoHideDuration) return
    const timer = setTimeout(() => {
      onClose && onClose()
    }, autoHideDuration)
    return () => clearTimeout(timer)
  }, [open, autoHideDuration, onClose])

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.25 }}
        >
          <SnackbarWrapper $severity={severity}>
            <Message>{message}</Message>
            {onClose && (
              <CloseBtn onClick={onClose}>
                <CloseIcon size={16} fill="currentColor" />
              </CloseBtn>
            )}
          </SnackbarWrapper>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

SnackbarAlert.propTypes = {
  open: PropTypes.bool,
  severity: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
  message: PropTypes.string,
  onClose: PropTypes.func,
  autoHideDuration: PropTypes.number,
}

SnackbarAlert.defaultProps = {
  open: false,
  severity: 'info',
  autoHideDuration: 3000,
}
